import Crud from '@/views/Departments/Crud'
import Add from '@/views/Departments/Add'

const routes = {
  path: '/departments',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/departments',
      name: 'list-departments',
      component: Crud,
    },
    {
      path: '/departments/add',
      name: 'Departamento',
      component: Add,
    },
    {
      path: '/departments/edit/:id?',
      name: 'Departamento',
      component: Add,
    },
  ],
}

export default routes
